import { render, staticRenderFns } from "./LinkedAdmins.vue?vue&type=template&id=4bce1084&"
import script from "./LinkedAdmins.vue?vue&type=script&lang=js&"
export * from "./LinkedAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports